module.exports = __webpack_public_path__ + "static/github-59a6979d4be1bebb30841252c38613b9.png";